// eslint-disable-next-line
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import SearchConditionInput, { getSearchConditionPayload } from '../../../component/molecules/SearchConditionInput';
import { AppState } from '../../../redux/modules/store';
import { getSpecifiedCondition, makeSearchConditionDisplayStr } from '../../../Common';
import { ConditionItem } from '../../../external/Common';

const mapStateToProps = (appState: AppState) => {
  return {
    searchConditions: appState.SearchCondition,
    currentFilter: appState.currentFilterCondition,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    getSearchConditionBadge: (payload: getSearchConditionPayload) => {
      return getSearchConditionBadgeDisp(payload);
    },
    getSearchCondition: (payload: getSearchConditionPayload) => {
      return getSearchConditionDisp(payload);
    },
  };
};

/**
 * 適用中の検索条件の件数を返す
 * @param payload
 * @returns 適用中の検索条件の件数
 */
export function getSearchConditionBadgeDisp(payload: getSearchConditionPayload): number {
  if (payload.currentFilter.filterKey) {
    return 1;
  }

  // 検索条件が設定されている時は検索条件を表示
  const searchTitles: string[] = [];
  if (payload.searchConditions.length > 0) {
    payload.searchConditions.forEach((searchCondition) => {
      if (isExitValue(searchCondition.specifiedCondition)) {
        const param: ConditionItem = {
          branchConditionName: searchCondition.searchConditionName,
          specifiedCondition: searchCondition.specifiedCondition,
        };
        searchTitles.push(makeSearchConditionDisplayStr(param));
      }
    });
    return searchTitles.length;
  }

  return 0;
}

/**
 * 適用中の検索条件の文字列を返す
 * @param payload
 * @returns 適用中の検索条件の文字列
 */
export function getSearchConditionDisp(payload: getSearchConditionPayload): string {
  const title = '設定中の条件: ';
  // フィルタ設定されている時はフィルタを表示
  if (payload.currentFilter.filterKey) {
    console.log('フィルタ適用中');
    return `${title}${payload.currentFilter.filterTitle}`;
  }

  // 検索条件が設定されている時は検索条件を表示
  const searchTitles: string[] = [];
  const searchKeys: string[] = [];
  payload.searchConditions.forEach((searchCondition) => {
    searchKeys.push(searchCondition.searchConditionName);
  });
  if (searchKeys.length > 0) {
    console.log('検索条件適用中');

    searchKeys.forEach((key) => {
      if (isExitValue(getSpecifiedCondition(payload.searchConditions, key))) {
        const param: ConditionItem = {
          branchConditionName: key,
          specifiedCondition: getSpecifiedCondition(payload.searchConditions, key),
        };
        searchTitles.push(makeSearchConditionDisplayStr(param));
      }
    });
    return `${title}${searchTitles.join(',')}`;
  }

  // 検索条件が何も設定されてない時は「なし」
  return `${title}なし`;
}

function isExitValue(arrayStr: (string | null)[]): boolean {
  return arrayStr.filter((value) => value == null || value.trim()).length > 0;
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchConditionInput);
